/**
 * Нормализует значение поля, ограничивая его максимальной длиной
 * @param value - Значение поля
 * @param maxLength - Максимальная длина (по умолчанию 6)
 * @returns Нормализованное значение
 */
export const normalizeFieldMaxLength = (value: string | number | null | undefined, maxLength: number = 6): string | number | null | undefined => {
    if (!value) return value;
    const stringValue = String(value);
    return stringValue.length > maxLength ? stringValue.slice(0, maxLength) : stringValue;
};
